import React from "react";

import { cn } from "@/lib/utils";

interface SourceInlinePanelProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  onChange?: () => void;
  className?: string;
}

export function SourceInlinePanel({
  icon,
  title,
  subtitle,
  onChange,
  className,
}: SourceInlinePanelProps) {
  return (
    <div
      className={cn(
        "rounded-xl border bg-card/70 p-3 shadow-md backdrop-blur-sm md:p-4",
        "border-border/60 shadow-[0_8px_24px_-12px] shadow-primary/10",
        className,
      )}
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full border border-primary/40 bg-primary/10 text-primary shadow-sm">
            {icon}
          </div>
          <div className="space-y-1">
            <div className="text-sm font-semibold text-card-foreground">{title}</div>
            <p className="text-xs text-muted-foreground md:text-sm">{subtitle}</p>
          </div>
        </div>
        {onChange && (
          <button
            type="button"
            onClick={onChange}
            className="inline-flex items-center text-sm font-medium text-primary transition-colors hover:text-primary/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          >
            Change source
          </button>
        )}
      </div>
    </div>
  );
}
